import { FormCheckbox } from './checkbox'
import { FormSingleDatePicker } from './date-picker'
import {
  Form,
  FormLabel,
  FormDescription,
  FormMessage,
  FormField,
} from './form'
import { FormTextField, FormPasswordField } from './input'
import { FormRadioGroupItem, FormRadioGroupRoot } from './radio-group'
import { FormRating } from './rating'
import { FormSelectRoot, FormSelectTrigger, Select } from './select'
import { FormTextarea } from './textarea'

export const {
  Group: SelectGroup,
  Value: SelectValue,
  Content: SelectContent,
  Label: SelectLabel,
  Item: SelectItem,
  Separator: SelectSeparator,
} = Select

export {
  Form as Root,
  FormField as Field,
  FormLabel as Label,
  FormMessage as Message,
  FormDescription as Description,
  // Checkbox
  FormCheckbox as Checkbox,
  // TextField
  FormTextField as TextField,
  FormPasswordField as PasswordField,
  // Textarea
  FormTextarea as Textarea,
  // RadioGroup
  FormRadioGroupRoot as RadioGroup,
  FormRadioGroupItem as Radio,
  // Select
  FormSelectRoot as SelectRoot,
  FormSelectTrigger as SelectTrigger,
  // DatePicker
  FormSingleDatePicker as SingleDatePicker,
  // Rating
  FormRating as Rating,
}
